import type { GetTransportPayersResponse } from '@/types/TransportPayer.ts'
import { apiGet } from './ApiClient'

export async function getTransportPayers(): Promise<GetTransportPayersResponse> {
  return await apiGet<GetTransportPayersResponse>('/transport/payers')
}
